import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoaderState } from '@root/app.interfaces';

@Injectable()
export class LoaderService {
	private state$: BehaviorSubject<LoaderState> = new BehaviorSubject({
		visible: false,
		classes: [],
	});

	readonly loading$ = this.state$.asObservable();

	setLoading(isLoading: boolean, classes: string[] = []): void {
		if (!isLoading) {
			this.hide();
			return;
		}

		this.show(classes);
	}

	private show(classes: string[]): void {
		this.state$.next({ visible: true, classes });
	}

	private hide(): void {
		this.state$.next({ visible: false, classes: [] });
	}
}
